export default "__VITE_ASSET__f87375a1__"